// extracted by mini-css-extract-plugin
export default {"input_box":"generalField_input_box__cnSl9","btn":"generalField_btn__vHHQz"};